export function usePagination(filters, mode = "offset") {
  const filter = ref("");

  const pagination = ref({
    sortBy: "",
    descending: false,

    page: 1,
    rowsPerPage: 0,
    rowsNumber: null,

    currentCursor: null,
    nextCursor: null,
    previousCursor: null,
    direction: "next",

    mode,
  });

  const lastCursorPage = ref(1);

  watch(
    () => pagination.value.page,
    (page) => {
      if (mode !== "cursor" || !page || page === lastCursorPage.value) return;

      const movingNext = page > lastCursorPage.value;

      const { nextCursor, previousCursor } = pagination.value;

      pagination.value.direction = movingNext ? "next" : "previous";

      pagination.value.currentCursor = movingNext ? nextCursor : previousCursor;

      lastCursorPage.value = page;
    },
  );

  const params = computed(() => {
    const { sortBy, descending, rowsPerPage, page, currentCursor, direction } =
      pagination.value;

    const keys = {
      search: filter.value || null,
      sortBy: sortBy || null,
      page_size: rowsPerPage || null,
      ...unref(filters),
    };

    if (sortBy) keys.orderBy = descending ? "desc" : "asc";

    if (mode === "cursor") {
      keys.cursor = currentCursor;

      keys.direction = direction;
    } else {
      keys.offset = (page - 1) * rowsPerPage;
    }

    return keys;
  });

  const resetCursor = () => {
    Object.assign(pagination.value, {
      currentCursor: null,
      nextCursor: null,
      previousCursor: null,
      direction: "next",
      page: 1,
    });

    lastCursorPage.value = 1;
  };

  return { filter, pagination, params, resetCursor };
}
